import { Sparkles } from 'lucide-react';
import { esEmpresaDemo } from '../empresa-demo';

export const AVISO_ESTRATEGIA_DEMO =
  'En la prueba, las estrategias y las reglas se aplican sólo a los productos de ejemplo. Con el plan completo, las estrategias se aplican a tus productos.';

export const AVISO_DECISIONES_DEMO =
  'En la prueba, lo que propone Prixia es sobre los productos de ejemplo. Con el plan completo, las estrategias se aplican a tus productos.';

/**
 * Mini Prixia: el aviso de lo que la prueba alcanza, arriba de Estrategia y de
 * Decisiones. No es un error: el servidor ya limita a los productos de ejemplo y
 * esto lo dice antes de que alguien se pregunte por qué no ve los suyos.
 */
export function AvisoDemo({ texto, tour }: { texto: string; tour?: string }) {
  if (!esEmpresaDemo()) return null;
  return (
    <div
      role="note"
      data-tour={tour}
      className="flex items-start gap-2 rounded-xl border border-primary/30 bg-primary/5 px-4 py-3 text-sm"
    >
      <Sparkles className="mt-0.5 h-4 w-4 shrink-0 text-primary" aria-hidden="true" />
      <p>{texto}</p>
    </div>
  );
}
